import { get } from 'lodash';

import { hasQuebecInAddress } from '../../businessLogic/utils';
import {
  swtBaseTsbValue,
  installationFeeHourlyRate,
  installationFeeMinimum
} from './constants';
import {
  existingEquipmentVulcan,
  keyMonitorAdditionalEquipmentVulcan,
  keyMonitorIncludedEquipmentVulcan,
  keyProtectAdditionalEquipmentVulcan,
  keyProtectIncludedEquipmentVulcan,
  protectIncludedEquipmentCameraSelectionVulcan,
  smartCameraAdditionalEquipmentVulcan,
  smartCameraIncludedEquipmentCameraSelectionVulcan,
  takeoverEquipmentWired,
  takeoverEquipmentWireless
} from '../../../utils/constant';
import { getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const calculateSWT = (allEquipments, province) => {
  // const swtType = hasQuebecInAddress(province) ? 'swtQc' : 'swtRoc';
  const swtType = 'swtRoc';
  const selectedEquipmentKeys = Object.keys(allEquipments).filter(
    key => +get(allEquipments, `${key}.value`, 0) > 0
  );
  const sumFn = (acc, key) => {
    const item = get(allEquipments, key, {});
    const swt = +get(item, swtType, 0);
    const amount = +get(item, 'value', 0);

    return swt * amount + acc;
  };

  return selectedEquipmentKeys.reduce(sumFn, 0);
};

/**
 * Calculate installation fee based on SWT (Standard Work Time)
 * @param {Object} formFields - Form fields object
 * @param {string} secureBusinessPlanValue - Selected plan (vulMonitorTSB, vulProtectTSB, vulSmartCameraTSB)
 * @returns {number} Calculated installation fee
 */
export const calculateInstallationFee = (
  formFields,
  secureBusinessPlanValue
) => {
  const locale = getLocale();
  const {
    vulcanWebform: { vulMonitorTSB, vulProtectTSB, vulSmartCameraTSB }
  } = locale === 'en-US' ? EN : FR;
  const province = get(formFields, 'province_VUL.value', '');

  // Start with base TSB SWT value
  let totalSWT = swtBaseTsbValue;

  // Add SWT for selected products
  totalSWT += calculateSWT(formFields[existingEquipmentVulcan], province);
  totalSWT += calculateSWT(formFields[takeoverEquipmentWired], province);
  totalSWT += calculateSWT(formFields[takeoverEquipmentWireless], province);

  // Add SWT for selected products based on plan type
  if (secureBusinessPlanValue === vulMonitorTSB) {
    totalSWT += calculateSWT(
      formFields[keyMonitorIncludedEquipmentVulcan],
      province
    );
    totalSWT += calculateSWT(
      formFields[keyMonitorAdditionalEquipmentVulcan],
      province
    );
  } else if (secureBusinessPlanValue === vulProtectTSB) {
    totalSWT += calculateSWT(
      formFields[keyProtectIncludedEquipmentVulcan],
      province
    );
    totalSWT += calculateSWT(
      formFields[protectIncludedEquipmentCameraSelectionVulcan],
      province
    );
    totalSWT += calculateSWT(
      formFields[keyProtectAdditionalEquipmentVulcan],
      province
    );
  } else if (secureBusinessPlanValue === vulSmartCameraTSB) {
    totalSWT += calculateSWT(
      formFields[smartCameraIncludedEquipmentCameraSelectionVulcan],
      province
    );
    totalSWT += calculateSWT(
      formFields[smartCameraAdditionalEquipmentVulcan],
      province
    );
  }

  // Calculate installation fee: SWT × hourly rate
  let installationFee = totalSWT * installationFeeHourlyRate;

  // Apply minimum fee rule
  installationFee = Math.max(installationFee, installationFeeMinimum);

  // Round to 2 decimal places
  return Math.round(installationFee * 100) / 100;
};
